import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import Button from '../button';

function FormFileUpload(_ref) {
  var accept = _ref.accept,
      children = _ref.children,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      onChange = _ref.onChange,
      render = _ref.render,
      props = _objectWithoutProperties(_ref, ["accept", "children", "multiple", "onChange", "render"]);

  var ref = useRef();

  var openFileDialog = function openFileDialog() {
    ref.current.click();
  };

  var ui = render ? render({
    openFileDialog: openFileDialog
  }) : createElement(Button, _extends({
    onClick: openFileDialog
  }, props), children);
  return createElement("div", {
    className: "components-form-file-upload"
  }, ui, createElement("input", {
    type: "file",
    ref: ref,
    multiple: multiple,
    style: {
      display: 'none'
    },
    accept: accept,
    onChange: onChange
  }));
}

export default FormFileUpload;
//# sourceMappingURL=index.js.map